import { createActions } from '~/store/utils';

const { Types, Actions } = createActions({
  // on initial load, request to SSO first to validate a cookie
  VERIFY_REQUEST: null,
  VERIFY_FAILURE: null,
  VERIFY_SUCCESS: null,
  VERIFY_ERROR: ['error'],

  // get the current user
  SET_USER: ['user'],
  SET_TOKEN: ['token'],
  LOGOUT_AUTH: null,
});

export { Actions, Types };
